import React from "react";

import { UserCreditBalance } from "../../../../components/user-credit-balance";

interface ReduxProps {}

export const ProfileBalance: React.FC<ReduxProps> = () => {
  return <UserCreditBalance emphase_credit hide_level />;
};
